import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ColisAbimeStep from './ColisAbimeStep';

class ColisAbimeStepContainer extends React.Component {
    
    render() {
        return (
            <ColisAbimeStep {...this.props}/>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let colisLogistiques = state.colisLogistique.colisLogistiques.items;

    return {
        colisLogistiques: colisLogistiques
    };
};

//const mapDispatchToProps = (dispatch) => ({
//});

ColisAbimeStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(ColisAbimeStepContainer);